import { useEffect, useState } from "react";
import Controls, { controls } from "./Controls";
import Form from "./Form";
import { DragDropContext } from "react-beautiful-dnd";
import { Col, Row } from "react-bootstrap";

function FormBuilder({ formObject, setFormObject }) {
    const [formData, setFormData] = useState(formObject || []);

    useEffect(() => {
        setFormObject(formData);
    }, [formData, setFormObject]);
    const onDragEnd = (data) => {
        const { draggableId, source, destination } = data;
        if (source && destination) {
            if (source.droppableId === "controls_droppable") {
                // console.log("controls_droppable-----------------");
                const control = controls?.find((e) => e?.type === draggableId),
                    newFormControl = {
                        id: `${formData.length}`,
                        ...control,
                    };
                const newFormData = [...formData];
                newFormData.splice(destination.index, 0, newFormControl);
                setFormData(newFormData);
            }
            if (source.droppableId === "form_droppable") {
                if (source.index !== destination.index) {
                    // console.log("form_droppable-----------------");

                    const newFormData = [...formData];
                    const movedFormControl = newFormData.splice(
                        source.index,
                        1
                    )[0];
                    newFormData.splice(destination.index, 0, movedFormControl);
                    setFormData(newFormData);
                }
            }
        }
    };
    return (
        <DragDropContext onDragEnd={onDragEnd}>
            <Row className="form-builder mh-100 flex-column flex-md-row">
                <Col xs="12" md="6">
                    <Controls />
                </Col>
                <Col xs="12" md="6">
                    <Form
                        formData={formData}
                        updateFormData={(e) => {
                            setFormObject(e);
                        }}
                    />
                </Col>
            </Row>
        </DragDropContext>
    );
}

export default FormBuilder;
